import Theme from "./Theme";
import { useThemePalette } from "./ThemePaletteProvider";
export * from "./Theme";
export default Theme;

export { useThemePalette };
